@if (loading) {
	<lib-loading></lib-loading>
}
